import { SyntheticEvent } from 'react';
import styled from '@emotion/styled';
import { Option } from './Option';

type OptionShape = {
  id: string;
  label: string;
};

type Props = {
  options: Array<OptionShape>;
  onChange: (e: SyntheticEvent) => void;
};

const Options = ({ options, onChange }: Props) => {
  return (
    <ListUl>
      {options.map((option) => (
        <ListLi key={option.id}>
          <Option
            id={option.id}
            key={option.id}
            label={option.label}
            onChange={onChange}
          />
        </ListLi>
      ))}
    </ListUl>
  );
};

export { Options };

const ListUl = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 20px;
  margin-bottom: 0;
  padding-left: 0;
`;

const ListLi = styled.li`
  list-style: none;
`;
